import {AnyAbility, subject} from '@casl/ability';
import {IdentityProjection} from '../domain/src/account/queries/identity/identity.projection';

/**
 * Checks whether the identity has permission to perform an action on a
 * subject type in at least one tenant. Used by global/aggregated components
 * that are not scoped to a single tenant context.
 */
export function canInAnyTenant(
  ability: AnyAbility,
  identity: IdentityProjection,
  action: string,
  subjectType: string
): boolean {
  if (!identity?.accounts?.length) {
    return false;
  }

  return identity.accounts.some(account => ability.can(action, subject(subjectType, {tenantId: account.tenantId})));
}
